var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.43545e-07 7.85937C0.00740146 8.15653 0.123634 8.4526 0.294696 8.6453L6.18974 15.3266C6.67743 15.8266 7.39703 15.8365 7.86007 15.4247C8.32309 15.0132 8.36996 14.2174 7.95821 13.7544L3.79491 9.0384L20.0428 9.0384C20.6938 9.0384 21.2218 8.51042 21.2218 7.85932C21.2218 7.20823 20.6939 6.68025 20.0428 6.68025L3.79491 6.68025L7.95821 1.96428C8.36969 1.50126 8.31185 0.717761 7.86007 0.29395C7.38883 -0.148235 6.6012 -0.070925 6.18974 0.392089L0.294696 7.07307C0.0852534 7.30855 0.00246293 7.54321 -3.4356e-07 7.859L-3.43545e-07 7.85937Z",
    fill: "#153c4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.410aa884cf77322b7c31b305b0eed39d.svg";
export { ForwardRef as ReactComponent };